import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CarrierLookupModel } from 'app/generated/backend/party/api/carrier-lookup-model';

@Injectable()
export class FclCarrierLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<CarrierLookupModel[]>> {
		return this.http.get<JsonResourceResponse<CarrierLookupModel[]>>('api/v1/party/fclCarriers/lookup').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		FclCarrierLookupHandlerService
	]
})
export class FclCarrierLookupHandlerModule { }
